import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Page from 'components/pages/Base/Page/Page';

const StyledPlanSettingPage = styled(Page)`
  background-color: unset;

  .PlanSettingPage {
    &-content {
      display: flex;
      flex-direction: column;
      gap: ${props => props.theme.layout('2sp')};
      padding: 0 ${props => props.theme.spacing(3)} ${props => props.theme.spacing(3)} ${props => props.theme.spacing(3)};
  
      .ClientProfile {
        background-color: unset;
        padding: 0;
        max-width: 100%;

        .ProfileCard {
          &-title {
            ${props => props.theme.font2Css('h6')};
          }

          &-content {
            padding: 0;
          }
        }
      }
    }

    &-options {
      display: flex;
      position: relative;
      flex-direction: column;
      gap: ${props => props.theme.layout('2sp')};
      padding: ${props => props.theme.spacing(2)};
      border: 1px solid ${props => props.theme.property('palette.divider')};
      
      .InlineForm {
        .FormField-name-extraCredits {
          .SliderField-container {
            .MuiSlider-markLabel {
              transform: unset;
            }
            .MuiSlider-markLabel ~ .MuiSlider-markLabel {
              transform: translateX(-50%);
            }
            .MuiSlider-markLabel:not(:has(~ .MuiSlider-markLabel)) {
              transform: translateX(-100%);
            }
          }
        }
      }

      &-price {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        position: absolute;
        gap: ${props => props.theme.layout('0.5sp')};
        right: ${props => props.theme.spacing(2)};
        
        .H5 {
          font-weight: bold;
          line-height: ${props => props.theme.lineHeight('1f')};
        }
      }
      
      &-save {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  
  .PlanSettingPage-content {
    &:not(:has(.ClientPlanProfileCard)), &:has(.ClientPlanProfileCard .ProfileCardContent-empty) {
      .PlanSettingPage-options {
        display: none;
      }
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    .PlanSettingPage {
      &-content {
        padding: 0 ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)} ${props => props.theme.spacing(2)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledPlanSettingPage.propTypes = {
  theme: PropTypes.object
};

export default StyledPlanSettingPage;
